import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import Settings from '~/pages/Settings/Settings';
import ProtectedRoute from '~/routes/ProtectedRoute';

const SETTINGS_ROUTES: RouteObject[] = [
  {
    path: PATH.SETTINGS,
    element: (
      <ProtectedRoute>
        <Settings />
      </ProtectedRoute>
    ),
  },
];

export { SETTINGS_ROUTES };
